// Physical Edition-page override for the marketplace list config.
// leave it `undefined` to fall back to the global marketplaceListConfig default.
export const physicalEditionListConfig = {
  maxItems: undefined,
};

export default physicalEditionListConfig;
